











































import { Component } from "vue-property-decorator";

import Wrapper from "./Wrapper.vue";

import Input from "./input";

@Component({ components: { Wrapper } })
export default class SimpleInput extends Input {
  setPadding() {
    const slots = this.$slots.default
      ? (this.$slots.default[0].elm as HTMLElement)
      : undefined;
    if (slots) {
      this.input.style.paddingRight = slots.clientWidth + 10 + "px";
    }
  }

  mountedUtility() {
    this.setPadding();
  }
}
